import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, map, of, tap } from 'rxjs';
import { RoutingUtilsService } from './routing-utils.service';
import { ActivatedRouteSnapshot } from '@angular/router';
import { OepApiService } from './oep-api.service';

export interface BreadcrumbInterface {
  title: string;
  link: string;
}

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbsService implements OnDestroy {

  private moduleTitleSubject = new BehaviorSubject<string>('');
  private moduleTitleWithoutSideMenuSubject = new BehaviorSubject<string>('');

  moduleTitle$ = this.moduleTitleSubject.asObservable();
  moduleTitleWithoutSideMenu$ = this.moduleTitleWithoutSideMenuSubject.asObservable();

  constructor(
    private readonly routerUtilsService: RoutingUtilsService,
    private readonly oepApi: OepApiService
  ) { }

  retrieveBreadcrumbs$( iomId: string, elementId: string, parentRouteSnapshot?: ActivatedRouteSnapshot ): Observable<BreadcrumbInterface[]> {
    const parentStringUrl = parentRouteSnapshot && this.routerUtilsService.getStringUrl(parentRouteSnapshot) || '';
    return (elementId ? this.oepApi.getBreadcrumbs$(iomId, elementId) : of({ headerName: '', breadCrumbs: [] }) )
      .pipe(map(breadcrumbsDto => {const breadCrumbs = (breadcrumbsDto.breadCrumbs || []).map(bDto => ({
            title: bDto.name || '',
            link: parentStringUrl + '/step/' + bDto.id || ''
          })).filter(b => b.link && b.title);

          const additionalBreadcrumb: BreadcrumbInterface = {
            title: breadcrumbsDto.headerName || '',
            link: parentStringUrl + '/'
          };
          return [additionalBreadcrumb, ...breadCrumbs];
        }),
        tap(breadCrumbs => {
          if (breadCrumbs.length > 1) {
            this.moduleTitleSubject.next(breadCrumbs[2]?.title || '');
            this.moduleTitleWithoutSideMenuSubject.next(breadCrumbs[2]?.title || breadCrumbs[breadCrumbs.length - 1]?.title || '');
          }
        })
    );
  }

  ngOnDestroy(): void {
    throw new Error('Method not implemented.');
  }

}
